// src/utils/listFormat.js
//
// Text helpers for the phone list layouts (the mlist-* rows in index.css).
// Copied from the navigator lists (PatientListPage.js, AppointmentsPage.js),
// which keep their own local copies; the doctor lists import these.

const WEEKDAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
const MONTHS   = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

// "FOLLOW_UP" → "Follow up".
export const sentenceCase = (s = '') => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase().replace(/_/g, ' ');

// "2026-10-14" → "WED 14 OCT 2026". Parsed as a local date: new Date() on a
// bare ISO date is UTC midnight, which is the previous day west of Greenwich.
export function dateHeading(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
  if (!m) return 'NO DATE';
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return `${WEEKDAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

// "14:30:00" → "2:30 PM".
export function time12(value) {
  const m = /^(\d{1,2}):(\d{2})/.exec(value || '');
  if (!m) return '';
  const h = Number(m[1]);
  return `${h % 12 || 12}:${m[2]} ${h < 12 ? 'AM' : 'PM'}`;
}
